module.exports = __webpack_public_path__ + "img/activity-timeline.2bff5813.png";